import {
  CREATE_UPDATE_USER_TABLE_LAYOUT,
  CREATE_UPDATE_USER_TABLE_LAYOUT_SUCCESS,
  CREATE_UPDATE_USER_TABLE_LAYOUT_FAILURE,
  GET_ALL_USER_TABLE_LAYOUTS,
  SET_ALL_USER_TABLE_LAYOUTS,
  SET_ALL_USER_TABLE_LAYOUTS_FAILURE,
  GET_USER_TABLE_LAYOUT_BY_ID,
  SET_USER_TABLE_LAYOUT_BY_ID,
  SET_USER_TABLE_LAYOUT_BY_ID_FAILURE
} from '../types';

const initialState = {
  layouts: [],
  currentLayout: null,
  total: 0,
  loading: false,
  createUpdateLoading: false,
  error: null
};

const userTableLayoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_UPDATE_USER_TABLE_LAYOUT:
      return {
        ...state,
        createUpdateLoading: true,
        error: null
      };
    
    case CREATE_UPDATE_USER_TABLE_LAYOUT_SUCCESS:
      // Update existing layout in list if it exists, otherwise add it
      const existingLayoutIndex = state.layouts.findIndex(
        layout => layout.user_table_layout_id === action.data.user_table_layout_id
      );
      const updatedLayouts = existingLayoutIndex >= 0
        ? state.layouts.map((layout, index) => 
            index === existingLayoutIndex ? action.data : layout
          )
        : [...state.layouts, action.data];
      
      return {
        ...state,
        layouts: updatedLayouts,
        currentLayout: action.data,
        createUpdateLoading: false,
        error: null,
        total: existingLayoutIndex >= 0 ? state.total : state.total + 1
      };
    
    case CREATE_UPDATE_USER_TABLE_LAYOUT_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        error: action.error
      };
    
    case GET_ALL_USER_TABLE_LAYOUTS:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case SET_ALL_USER_TABLE_LAYOUTS:
      return {
        ...state,
        layouts: action.layouts,
        total: action.total,
        loading: false,
        error: null
      };
    
    case SET_ALL_USER_TABLE_LAYOUTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    
    case GET_USER_TABLE_LAYOUT_BY_ID:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case SET_USER_TABLE_LAYOUT_BY_ID:
      return {
        ...state,
        currentLayout: action.layout,
        loading: false,
        error: null
      };
    
    case SET_USER_TABLE_LAYOUT_BY_ID_FAILURE:
      return {
        ...state,
        currentLayout: null,
        loading: false,
        error: action.error
      };
    
    default:
      return state;
  }
};

export default userTableLayoutReducer;

